/* src/app/components/payroll/timesheets/timesheet-detail-view/timesheet-detail-view.component.css */
.custom-width {
  max-width: 160px;
  min-width: 50px;
  display: inline-block;
  margin: 0 6px;
}
.p-datatable .p-datatable-tbody > tr > td {
  padding: 0 !important;
}
.control-height {
  height: 30px;
}
.custom-btn-row {
  display: flex;
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.error-border {
  border: 1px solid red !important;
}
.edit-button {
  padding-right: 15px;
}
.ppl-table-container th,
.ppl-table-container td {
  padding: 8px !important;
}
.consumer-section {
  padding-left: 15px;
}
.derived-elements-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}
.derived-elements-table th,
.derived-elements-table td {
  padding: 8px 12px;
  border: 1px solid #e8e8e8;
  text-align: right;
}
.derived-elements-table th:first-child,
.derived-elements-table td:first-child {
  text-align: left;
}
.derived-elements-table thead tr {
  background-color: #fafafa;
  font-weight: 600;
}
.font-weight-600 {
  font-weight: 600;
}
:host ::ng-deep tr:has(> td.no-split-entries) > td.expand-row .expand-row-icon-btn {
  visibility: hidden;
  pointer-events: none;
}
/*# sourceMappingURL=timesheet-detail-view.component-KQBJFE6V.css.map */
